import React from 'react'
import { TextField, useTheme } from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import Text from '../../Text'
import { brtToday, PERIOD_PRESETS, MAX_CUSTOM_DAYS } from './periodRange'

// Seletor de período: chips de preset (Hoje / 7 dias / 30 dias) + intervalo
// personalizado com dois date pickers. Emite { period, customStart, customEnd }.
// Compartilhado entre o relatório de envios e o do SmartFilter.
export default function PeriodSelector({ period, customStart, customEnd, incomplete, onChange }) {
  const theme = useTheme()
  const today = brtToday()
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <CalendarMonthIcon style={{ fontSize: 18, opacity: 0.45 }} />
        {PERIOD_PRESETS.map((p) => {
          const active = period === p.key
          return (
            <button
              key={p.key}
              onClick={() => onChange({ period: p.key, customStart, customEnd })}
              className="px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors"
              style={{
                background: active ? theme.palette.primary.main : (theme.isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'),
                color: active ? '#fff' : 'inherit',
                border: `1px solid ${active ? theme.palette.primary.main : 'transparent'}`,
              }}
            >
              {p.label}
            </button>
          )
        })}
      </div>
      {
        period === 'custom' &&
        <div className="flex flex-wrap items-center gap-3">
          <TextField
            type="date"
            size="small"
            label="Início"
            InputLabelProps={{ shrink: true }}
            value={customStart || ''}
            inputProps={{ max: customEnd || today }}
            onChange={(e) => onChange({ period: 'custom', customStart: e.target.value, customEnd })}
          />
          <TextField
            type="date"
            size="small"
            label="Fim"
            InputLabelProps={{ shrink: true }}
            value={customEnd || ''}
            inputProps={{ max: today, min: customStart || undefined }}
            onChange={(e) => onChange({ period: 'custom', customStart, customEnd: e.target.value })}
          />
          <Text className="text-xs opacity-40" style={{ color: incomplete ? theme.palette.warning.main : undefined }}>
            {incomplete ? 'Selecione início e fim para aplicar' : `Máx. ${MAX_CUSTOM_DAYS} dias`}
          </Text>
        </div>
      }
    </div>
  )
}
